import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // Find the element corresponding to the hash
      const element = document.getElementById(location.hash.slice(1)); // Remove '#' from hash
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' }); // Smooth scroll to element
      }
    }
  }, [location]); // Triggered whenever the location (hash) changes

  return null;
}

export default ScrollToHash;
